export * from "./assert-empty";
export * from "./assert-never";
//# sourceMappingURL=index.js.map